module.exports = __webpack_public_path__ + "img/448.3e315c71.jpg";